"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _supplier = require("@/api/supplier");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PaymentRecord',
  data: function data() {
    return {
      timeVal: [],
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        page: 1,
        limit: 20
      },
      stats: {
        totalAmount: '0.00',
        totalBalance: '0.00',
        totalIntegral: '0.00'
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getStats();
  },
  methods: {
    discountLabel: function discountLabel(rate) {
      var r = parseFloat(rate);
      if (!r || r >= 1) return '';
      return (r * 10).toFixed(1).replace('.0', '') + '折';
    },
    handleReset: function handleReset() {
      this.tableFrom.dateLimit = '';
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _supplier.getPaymentListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getStats: function getStats() {
      var _this2 = this;
      (0, _supplier.getPaymentStatsApi)().then(function (res) {
        if (res) {
          _this2.stats = {
            totalAmount: res.totalAmount ? Number(res.totalAmount).toFixed(2) : '0.00',
            totalBalance: res.totalBalance ? Number(res.totalBalance).toFixed(2) : '0.00',
            totalIntegral: res.totalIntegral ? Number(res.totalIntegral).toFixed(2) : '0.00'
          };
        }
      }).catch(function () {});
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};